var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 0H2.22222C1.63285 0 1.06762 0.234126 0.650874 0.650874C0.234127 1.06762 0 1.63285 0 2.22222V28.8889C0 29.4783 0.234127 30.0435 0.650874 30.4602C1.06762 30.877 1.63285 31.1111 2.22222 31.1111H17.7778C18.3671 31.1111 18.9324 30.877 19.3491 30.4602C19.7659 30.0435 20 29.4783 20 28.8889V2.22222C20 1.63285 19.7659 1.06762 19.3491 0.650874C18.9324 0.234126 18.3671 0 17.7778 0ZM11.1111 28.8889H8.88889V26.6667H11.1111V28.8889ZM2.22222 24.4444V2.22222H17.7778V24.4444H2.22222Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.734ed617dfdeefe5e3183436202bbc81.svg";
export { ForwardRef as ReactComponent };